import React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import './Loading.styl';
import classnames from 'classnames';

/**
 * TODO: Add Mediafly loading component
 * @deprecated
 */
export default class Loading extends React.PureComponent {
  render() {
    return (
      <div className={classnames('ev-loading', this.props.className)}>
        <RefreshIndicator size={40} left={10} top={0} status="loading" className="spinner" />
      </div>
    );
  }
}
